<template>
    <div class="container-fluid">
        <!-- <pre>{{ units }}</pre> -->

        <div class="row mt-3">

            <div class="col-md-4" v-for="unit in units.slice(0, 3)" :key="unit.id">
                <article class="unit-card" role="button" @click="goToRoom(unit)">
                    <div class="unit-cover">
                        <img class="unit-img" :src="unit.imageCoverUrl" :alt="`ห้อง ${unit.unitNumber}`" />

                        <div class="cover-badges">
                            <span class="text-capitalize badge-ready">
                                {{ formatProjectStatus(unit.projectStatus) }}
                            </span>


                            <span v-if="isMinPrice(unit)" class="badge-ribbon">
                                💰 ถูกสุดในโครงการ
                            </span>

                        </div>
                    </div>

                    <div class="unit-body">
                        <div class="d-flex align-items-baseline gap-2">
                            <h5 class="unit-title mb-0">
                                แปลง {{ unit.unitNumber }}
                            </h5>

                            <span class="small text-addressNo">
                                บ้านเลขที่ {{ unit.addressNo }}
                            </span>
                        </div>

                        <div class="unit-subtitle">
                            {{ unitProjectName }} {{ unitLocation }}
                        </div>

                        <div class="unit-specs">
                            <!-- Bedrooms -->
                            <span v-if="safeNum(unit.bedrooms) > 0" class="spec with-divider">
                                <span class="spec-ic">
                                    <img src="@/assets/images/bed.svg" class="img-fluid" />
                                </span>
                                <span>{{ safeNum(unit.bedrooms) }}</span>
                            </span>

                            <!-- Bathrooms -->
                            <span v-if="safeNum(unit.bathrooms) > 0" class="spec with-divider">
                                <span class="spec-ic">
                                    <img src="@/assets/images/toilet.svg" class="img-fluid" />
                                </span>
                                <span>{{ safeNum(unit.bathrooms) }}</span>
                            </span>

                            <!-- Parking -->
                            <span v-if="safeNum(unit.parkingSpots) > 0" class="spec">
                                <span class="spec-ic">
                                    <img src="@/assets/images/car.svg" class="img-fluid" />
                                </span>
                                <span>{{ safeNum(unit.parkingSpots) }}</span>
                            </span>
                        </div>


                        <div class="d-flex flex-wrap gap-2 align-items-center">
                            <span class="badge bg-text-subtle text-dark px-2 py-2">
                                ขนาดที่ดิน {{ unit.areaSize }} ตร.ม.
                            </span>


                            <span class="badge bg-text-subtle text-dark px-2 py-2">
                                พื้นที่ใช้สอย {{ unit.usableArea }}
                            </span>

                            <span class="badge bg-text-subtle text-dark px-2 py-2">
                                แบบบ้าน {{ unit.model }}
                            </span>

                            <div v-if="hasTag(unit, 'PET_FRIENDLY')" class="d-inline-flex align-items-center">
                                <span class="badge px-2 py-2 bg-subtle">
                                    Pet Friendly
                                </span>
                            </div>
                        </div>

                        <div class="unit-divider"></div>

                        <div class="booking-row">
                            <div class="booking-label">
                                จองเริ่ม {{ formatMoney(unit.bookingPrice) }}
                            </div>
                        </div>

                        <div class="price-bar">
                            <div class="price-top">
                                <span class="price-old" v-if="isDiscount(unit)">
                                    {{ formatMoney(unit.sellingPrice) }}
                                </span>

                                <span class="price-discount" v-if="isDiscount(unit)">
                                    <svg viewBox="0 0 512 512" width="15" height="15" fill="white"
                                        style="transform: rotate(-10deg)">
                                        <path
                                            d="M32.5 96l0 149.5c0 17 6.7 33.3 18.7 45.3l192 192c25 25 65.5 25 90.5 0L483.2 333.3c25-25 25-65.5 0-90.5l-192-192C279.2 38.7 263 32 246 32L96.5 32c-35.3 0-64 28.7-64 64zm112 16a32 32 0 1 1 0 64 32 32 0 1 1 0-64z" />
                                    </svg>
                                    ลด {{ formatMoney(unit.specialDiscountPrice) }}
                                </span>
                            </div>

                            <div class="price-net">
                                {{ formatMoney(unit.netSellingPrice || unit.sellingPrice) }}
                            </div>

                        </div>
                    </div>
                </article>
            </div>


        </div>
    </div>
</template>
  
  
<script>

export default {
    name: "Home",
    data() {
        return {
            loading: false,
            units: []
        };
    },

    computed: {
        projectId() {
            return (
                String(this.$route?.params?.projectId || "").trim() ||
                String(this.$route?.query?.projectId || "").trim()
            );
        },

        unitProjectName() {
            return this.projectName;
        },
        unitLocation() {
            return this.projectLocation;
        },
        minNetPrice() {
            if (!Array.isArray(this.units) || !this.units.length) return null;

            const prices = this.units
                .map(u => Number(u?.netSellingPrice ?? u?.sellingPrice))
                .filter(n => Number.isFinite(n) && n > 0);

            return prices.length ? Math.min(...prices) : null;
        }
    },

    watch: {
        // ✅ เปลี่ยน URL แล้วโหลดใหม่ทันที
        projectId: {
            immediate: true,
            handler() {
                this.fetchIBooking();
            }
        }
    },

    methods: {
        async fetchIBooking() {
            if (!this.projectId) {
                this.units = [];
                return;
            }

            this.loading = true;
            try {
                const data = await this.$store.dispatch(
                    "ibooking/getIBooking",
                    this.projectId
                );

                console.log(data);

                if (Array.isArray(data)) {
                    this.units = data.sort(
                        (a, b) =>
                            Number(a.netSellingPrice ?? a.sellingPrice ?? 0) -
                            Number(b.netSellingPrice ?? b.sellingPrice ?? 0)
                    );
                } else {
                    this.units = [];
                }
            } catch (e) {
                console.error("iBooking error", e);
                this.units = [];
            } finally {
                this.loading = false;
            }
        },

        goToRoom(unit) {
            if (!unit?.id) return;
            const lang = this.$i18n?.locale || "th";
            const url = `https://britania.co.th/ibooking/${lang}/room/${unit.id}`;
            window.open(url, "_blank");
        },
        isMinPrice(unit) {
            if (!unit || this.minNetPrice == null) return false;

            const p = Number(unit?.netSellingPrice ?? unit?.sellingPrice);
            return Number.isFinite(p) && p === this.minNetPrice;
        },

        // ---------- UI helpers ----------
        parseTags(unit) {
            try {
                const t = unit?.tags;
                if (!t) return [];
                if (Array.isArray(t)) return t;
                if (typeof t === "string") return JSON.parse(t);
                return [];
            } catch {
                return [];
            }
        },

        hasTag(unit, key) {
            return this.parseTags(unit).includes(key);
        },

        isDiscount(unit) {
            const n = Number(unit?.specialDiscountPrice);
            return Number.isFinite(n) && n > 0;
        },

        safeText(v) {
            const s = (v ?? "").toString().trim();
            return s || "-";
        },

        safeNum(v) {
            const n = Number(v);
            return Number.isFinite(n) ? n : "-";
        },

        formatArea(v) {
            const n = Number(v);
            if (!Number.isFinite(n)) return "-";
            return `${n.toFixed(2)} ตร.ม.`;
        },

        formatMoney(v) {
            const n = Number(v);
            if (!Number.isFinite(n)) return "฿0";
            const int = Math.round(n); // ราคาเป็นบาท ไม่ต้องทศนิยม
            return "฿" + int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        formatProjectStatus(status) {
            const s = String(status || "").toLowerCase();

            if (s === "ready to move") return "Ready";
            if (s === "pre-sale" || s === "presale") return "Presale";

            // fallback เผื่อมีค่าอื่นในอนาคต
            return s.replace(/\b\w/g, c => c.toUpperCase());
        }

        // ... helpers เดิมของคุณ ...
    }
};
</script>

  
<style scoped>
.unit-card {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    display: flex;
    flex-direction: column;
}

.unit-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 36px rgba(0, 0, 0, 0.16);
}

.unit-cover {
    position: relative;
    height: 245px;
    background: #f2f2f2;
}

.unit-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.cover-action {
    position: absolute;
    top: 10px;
    right: 10px;
}

.action-ic {
    width: 34px;
    height: 34px;
    display: grid;
    place-items: center;
    border-radius: 10px;
    background: rgba(0, 0, 0, 0.35);
    color: #fff;
    font-size: 18px;
    line-height: 1;
}

.cover-badges {
    position: absolute;
    left: 10px;
    bottom: 10px;
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;
}

.badge-ready {
    background: rgba(0, 0, 0, 0.65);
    color: #fff;
    padding: 6px 10px;
    border-radius: 999px;
    font-weight: 700;
    font-size: 12px;
}

.badge-hot {
    background: rgba(206, 80, 74, 0.8);
    color: #fff;
    padding: 6px 10px;
    border-radius: 999px;
    font-weight: 500;
    font-size: 12px;
}

.badge-ribbon {
    background: rgba(42, 103, 173, 0.8);
    color: #fff;
    padding: 6px 10px;
    border-radius: 999px;
    font-weight: 500;
    font-size: 12px;
}

.unit-body {
    padding: 12px 12px 12px;
}

.unit-title {
    margin: 0 0 4px;
    font-weight: 800;
    color: #091d78;
}

.text-addressNo {
    margin: 0 0 4px;
    color: #091d78;
}


.unit-subtitle {
    color: #7a8797;
    font-size: 13px;
    margin-bottom: 10px;
}

.unit-specs {
    display: flex;
    gap: 12px;
    align-items: center;
    color: #5f6b7a;
    font-size: 13px;
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.spec {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.spec-ic {
    opacity: 0.75;
    font-size: 14px;
}

.unit-pill-row {
    margin-bottom: 10px;
}

.pill-blue {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 999px;
    background: #1f2f5f;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
}

.unit-divider {
    height: 1px;
    background: #edf0f3;
    margin: 10px 0;
}

.booking-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 10px;
}

.booking-label {
    color: #222;
    font-weight: 700;
}

.booking-price {
    color: #222;
    font-weight: 800;
}

.price-bar {
    position: relative;
    border-radius: 8px;
    padding: 12px 12px 14px;
    color: #fff;
    overflow: hidden;
    background: linear-gradient(90deg, #FD6873 0%, #F0434F 100%);
}

.price-top {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 6px;
    flex-wrap: wrap;
}

.price-old {
    text-decoration: line-through;
    opacity: 0.9;
    font-weight: 500;
    font-size: 12px;
}

.price-discount {
    background: #1bb35c;
    padding: 4px 10px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 12px;
}

.price-net {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0.2px;
}


.spec {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding-right: 12px;
    font-size: 13px;
    color: #5f6b7a;
    position: relative;
}

.spec.with-divider::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 14px;
    width: 1px;
    background: #e5e8ec;
}

.paw-watermark {
    position: absolute;
    right: 10px;
    bottom: 5px;
    opacity: inherit;
    pointer-events: none;
}

.paw-img {
    width: 75px;
    /* ปรับขนาดได้ */
    height: 75px;
    transform: rotate(20deg);
}

.bg-subtle {
    background-color: #fef1e7;
    color: #f46e0b;
    font-weight: 500;
}

.bg-text-subtle {
    background-color: #f0f0f0;
    font-weight: 500;
}

.pet-friendly-badge {
    background-color: #fff4ec;
    /* ส้มอ่อน */
    color: #ff6a00;
    /* ส้มเข้ม */
    font-weight: 600;
    border-radius: 6px;
    /* มนเล็กน้อย */
    font-size: 12px;
    line-height: 1;
}

.pet-icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
    animation: pet-wiggle 2.0s ease-in-out infinite;
    transform-origin: left center;
}

@keyframes pet-wiggle {
    0% {
        transform: rotate(0deg) translateX(0);
    }

    20% {
        transform: rotate(14deg) translateX(2px);
    }

    40% {
        transform: rotate(-12deg) translateX(-2px);
    }

    60% {
        transform: rotate(12deg) translateX(2px);
    }

    80% {
        transform: rotate(-10deg) translateX(-2px);
    }

    100% {
        transform: rotate(0deg) translateX(0);
    }
}
</style>